import { forwardRef } from "react"
import Select, { MenuPosition, type Props as SelectProps } from "react-select"
import CreatableSelect from "react-select/creatable"
import { FormControl, FormHelperText } from "@mui/material"
import type { BulkDropdownOption } from "../../screens/ServiceAgreements/types"

interface DropdownProps {
  label?: string
  name?: string
  options: BulkDropdownOption[]
  value?: BulkDropdownOption | null
  defaultValue?: BulkDropdownOption | null
  onChange?: (selectedOption: BulkDropdownOption | null) => void
  onCreateOption?: (inputValue: string) => void
  error?: boolean
  helperText?: string | null
  isDisabled?: boolean
  isClearable?: boolean
  isCreatable?: boolean
  placeholder?: string
  customStyles?: SelectProps<BulkDropdownOption, false>["styles"]
  menuPortalTarget?: HTMLElement | null;
  menuPosition?: MenuPosition | undefined
}

export const Dropdown = forwardRef<any, DropdownProps>(
  (
    {
      label,
      options,
      value,
      defaultValue,
      onChange,
      onCreateOption,
      error,
      helperText,
      isDisabled,
      isClearable,
      isCreatable,
      placeholder,
      customStyles,
      menuPortalTarget,
      menuPosition
    },
    ref,
  ) => {
    const SelectComponent = isCreatable ? CreatableSelect : Select

    return (
      <FormControl
        error={error}
        fullWidth
        sx={{ 
          display: "flex",
          flexDirection: "column",
          "& .MuiFormHelperText-root": {
            minHeight: "20px",
            margin: "4px 0 0 0", 
          },
        }}
      >
        {label && (
          <label
            style={{
              marginBottom: "8px",
              display: "block",
              color: "#334155",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {label}
          </label>
        )}
        <SelectComponent
          ref={ref as any}
          options={options}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          onCreateOption={isCreatable ? onCreateOption : undefined}
          isDisabled={isDisabled}
          isClearable={isClearable}
          placeholder={placeholder || "Select..."}
          styles={customStyles}
          menuPortalTarget={menuPortalTarget}
          menuPosition={menuPosition}
        />
        <FormHelperText
          error={error}
          sx={{
            visibility: helperText ? "visible" : "hidden",
          }}
        >
          {helperText } 
        </FormHelperText>
      </FormControl>
    )
  },
)

Dropdown.displayName = "Dropdown"

export default Dropdown

